const model = {
    alert: null,
    loading: false,
    error: null,
};

export default model;